import api from './http';

export const IntegrationsAPI = {
  cecStatus: () => api.get('/integrations/cec/status').then((response) => response.data),
  cecDiagnostics: () => api.get('/integrations/cec/diagnostics').then((response) => response.data),
  syncBlingContacts: () => api.post('/integrations/bling/sync/contacts').then((response) => response.data),
  syncBlingProducts: (payload = {}) => api.post('/integrations/bling/sync/products', payload).then((response) => response.data),
  syncAuvoCustomers: (payload = {}) => api.post('/integrations/auvo/sync/customers', payload).then((response) => response.data),
  syncAuvoProducts: (payload = {}) => api.post('/integrations/auvo/sync/products', payload).then((response) => response.data),
  syncAuvoOrders: () => api.post('/integrations/auvo/sync/orders').then((response) => response.data),
  syncAuvoTasks: (payload = {}) => api.post('/integrations/auvo/sync/tasks', payload).then((response) => response.data),
  syncAuvoExpenses: (payload = {}) => api.post('/integrations/auvo/sync/expenses', payload).then((response) => response.data),
  oneDriveStatus: () => api.get('/integrations/onedrive/status').then((response) => response.data),
  oneDriveConnectUrl: () => api.get('/integrations/onedrive/connect-url').then((response) => response.data),
};
